import { createLoader } from '@meteor/data-hooks';
import { withAuth } from '../../user';
import { organizationClient } from '../client';

export let ticketsLoader = createLoader({
  name: 'tickets',
  hash: i => i.organizationId,
  fetch: (i: { organizationId: string }) =>
    withAuth(() => organizationClient.support.listTickets(i)),
  mutators: {
    createTicket: (
      i: { message: string | undefined; subject: string; url: string },
      { input: { organizationId } }
    ) =>
      withAuth(() =>
        organizationClient.support.createTicket({
          organizationId,
          ...i
        })
      )
  }
});

export let ticketLoader = createLoader({
  name: 'ticket',
  hash: i => i.organizationId + i.ticketId,
  fetch: (i: { organizationId: string; ticketId: string }) =>
    withAuth(() => organizationClient.support.getTicket(i)),
  mutators: {}
});

export let ticketMessagesLoader = createLoader({
  name: 'ticketMessages',
  hash: i => i.organizationId + i.ticketId,
  fetch: (i: { organizationId: string; ticketId: string }) =>
    withAuth(() => organizationClient.support.listMessages(i)),
  mutators: {
    createMessage: (i: { message: string }, { input: { organizationId, ticketId } }) =>
      withAuth(() =>
        organizationClient.support.createMessage({
          organizationId,
          ticketId,
          ...i
        })
      ),

    createAttachment: (
      i: { attachment: { name: string; url: string } },
      { input: { organizationId, ticketId } }
    ) =>
      withAuth(() =>
        organizationClient.support.createAttachment({
          organizationId,
          ticketId,
          ...i
        })
      )
  }
});

export let useTickets = (organizationId: string | null | undefined) => {
  let ticket = ticketsLoader.use(organizationId ? { organizationId } : null);

  return {
    ...ticket,
    createTicketMutator: ticket.useMutator('createTicket')
  };
};

export let useTicket = (
  organizationId: string | null | undefined,
  ticketId: string | null | undefined
) => {
  let ticket = ticketLoader.use(
    organizationId && ticketId ? { organizationId, ticketId } : null
  );

  return {
    ...ticket
  };
};

export let useTicketMessages = (
  organizationId: string | null | undefined,
  ticketId: string | null | undefined
) => {
  let ticket = ticketMessagesLoader.use(
    organizationId && ticketId ? { organizationId, ticketId } : null
  );

  return {
    ...ticket,
    createMessageMutator: ticket.useMutator('createMessage'),
    createAttachmentMutator: ticket.useMutator('createAttachment')
  };
};
